import Cookies from 'universal-cookie';
import { importMapUrl } from '../../import-map';

const cookies = new Cookies();
const parsedUrl = new URL(importMapUrl);
let marketSelectorFlow = false;

export default function marketMiddleware(utils) {
    const { currentMarket, setCurrentSelectedMarket } = utils;
    if (!marketSelectorFlow && cookies.get('currentMarket') && currentMarket !== parsedUrl.searchParams.get('market')) {
        window.location.reload();
    }
    return {
        ...utils,
        setCurrentSelectedMarket: (market) => {
            marketSelectorFlow = true;
            return setCurrentSelectedMarket(market);
        },
    };
}
